module.exports = new __parcel__URL__("illustration.6ab997dd.jpg").toString();